let moduleName = 'services';

class ApiFactory {

    constructor($http, $q, CONFIG, $cookies){
        //Setting variables
        this.http = $http;
        this.q = $q;
        this.const = CONFIG;
        this.cookies = $cookies;
        this.config = { };
    }

    /***
     * Get Content Types
     * @returns {*|Promise.<TResult>}
     */
    getContentTypes(version) {
        let d = this.q.defer();

        console.log(this.cookies.get('token'));

        let request = this.http({
            method: 'GET',
            timeout: d.promise,
            url: `${this.const.cmApiUrl}content_types?order=name`
        });

        let start = new Date().getTime();
        let promise = request.then(
            (response) => {
                console.log(`time taken for request: ${new Date().getTime() - start}ms`);
                return (response.data);
            },
            (error) => {
                console.error('Error in getContentTypes() Service', error);
                this.q.reject(error);
            }
        );

        promise.abort = () => {
            d.resolve();
        };

        promise.finally(
            () => {
                promise.abort = angular.noop;
                d = request = promise = null;
            }
        );

        return (promise);
    }


    /**
     * ApiFactory static
     * @param $http
     * @param $q
     * @returns {ApiFactory}
     */
    static apiFactory($http, $q, CONFIG, $cookies){
        return new ApiFactory($http, $q, CONFIG, $cookies);
    }
}

ApiFactory.apiFactory.$inject = ['$http', '$q', 'CONFIG', '$cookies'];

angular.module(moduleName, [])
    .factory('ApiFactory', ApiFactory.apiFactory);


export default moduleName;



// WEBPACK FOOTER //
// ./src/app/services/services.js